<template>
  <div>
    {{ rowData }}
    <table class="table table-striped">
      <thead>
        <tr>
          <th>名稱</th>
          <th>位置</th>
          <th>動作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rowData.system_set">
          <td>{{ row.name }}</td>
          <td>{{ rowData.department.name }}</td>
          <td><button class="btn btn-danger">刪除</button></td>
        </tr>
      </tbody>
    </table>
    
    <div class="form-inline">
      <select class="form-control col-10">
        <option>Default select</option>
      </select>
      <div class="col-2">
        <button class="btn btn-primary">新增</button>
      </div>
    </div>

  </div>
</template>


<script>
export default {
  name: 'AreaSettingsDetail',
  props: [
    'rowData',
    'rowIndex',
  ],
};
</script>



// WEBPACK FOOTER //
// AreaSettingsDetail.vue?2c164330